module.exports = __webpack_public_path__ + "img/ru.julia.0f90523d.jpg";